import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("cobranca");

const reqNotaFiscal = {
	listRelatorio: async function (body) {
		return apiServer
			.get("cobranca/v1/nota-fiscal/relatorio", {
				headers: { banco: banco },
				params: body
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	pendencias: async function (body) {
		return apiServer
			.get("cobranca/v1/nota-fiscal/pendencias", {
				headers: { banco: banco },
				params: body
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	fechamento: async function (body) {
		return apiServer
			.get("cobranca/v1/nota-fiscal/fechamento", {
				headers: { banco: banco },
				params: body
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	xml: async function (id) {
		return apiServer
			.get(`cobranca/v1/nota-fiscal/${id}/xml`, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	pdf: async function (id) {
		return apiServer
			.get(`cobranca/v1/nfce/${id}/pdf`, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	consultar: async function (id) {
		return apiServer
			.get(`cobranca/v1/nfce/${id}/consultar`, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	transmitir: async function (id) {
		return apiServer
			.post(
				`cobranca/v1/nfce/${id}/transmitir`,
				{},
				{
					headers: { banco: banco },
				}
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	cancelar: async function (id, justificativa) {
		return apiServer
			.post(
				"cobranca/v1/nfce/cancelar",
				{ id_nota_fiscal: id, justificativa },
				{
					headers: { banco: banco },
				}
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	chavesSefaz: async function (body) {
		return apiServer
			.get("cobranca/v1/sefaz/nfce/chaves", {
				headers: { banco: banco },
				params: body
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	xmlSefaz: async function (chave) {
		return apiServer
			.get(`cobranca/v1/sefaz/nfce/xml/${chave}`, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqNotaFiscal;
